import {
    mapStatesForList,
    mapStatesForOne,
} from './common';

function mapGetOneImpactingPolicyData(responseData) {
    return {
        ...responseData,
        ...mapStatesForOne(responseData),
    };
}

function mapGetListImpactingPoliciesData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapStatesForList(data),
    }));
}

export { mapGetOneImpactingPolicyData, mapGetListImpactingPoliciesData };
